import { render, staticRenderFns } from "./PreciosParcelasPorZonasComponent.vue?vue&type=template&id=60b836e4"
import script from "./PreciosParcelasPorZonasComponent.vue?vue&type=script&lang=js"
export * from "./PreciosParcelasPorZonasComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports